// v1
// Path: frontend/src/components/SyncHub/shared/DiffMetricCards.jsx
// Inputs: diffPreviewData (object containing totalPbsRecords, toCreate, toUpdate, totalQbRecords)
// Outputs: 4 KPI metric cards for Diff Analyzer
// Summary: Centralized KPI cards for Sync previews to eliminate duplicates.

import React from 'react';

export default function DiffMetricCards({ diffPreviewData }) {
    if (!diffPreviewData) return null;
    
    return (
        <div className="grid grid-cols-5 gap-3">
            <div className="bg-slate-850 border border-slate-750 rounded-xl p-3 text-center">
                <div className="text-xl font-bold text-white">{diffPreviewData.totalPbsRecords ?? 0}</div>
                <div className="text-[11px] text-slate-400">ERP Records Evaluated</div>
            </div>
            <div className="bg-slate-850 border border-emerald-900/60 rounded-xl p-3 text-center">
                <div className="text-xl font-bold text-emerald-400">+{diffPreviewData.toCreate?.length ?? 0}</div>
                <div className="text-[11px] text-slate-400">New in Target</div>
            </div>
            <div className="bg-slate-850 border border-amber-900/60 rounded-xl p-3 text-center">
                <div className="text-xl font-bold text-amber-400">{diffPreviewData.toUpdate?.length ?? 0}</div>
                <div className="text-[11px] text-slate-400">Need Updates</div>
            </div>
            <div className="bg-slate-850 border border-blue-900/60 rounded-xl p-3 text-center">
                <div className="text-xl font-bold text-blue-400">{diffPreviewData.unchanged?.length ?? 0}</div>
                <div className="text-[11px] text-slate-400">Already In Sync</div>
            </div>
            <div className="bg-slate-850 border border-purple-900/60 rounded-xl p-3 text-center">
                <div className="text-xl font-bold text-purple-300">{diffPreviewData.totalQbRecords ?? 0}</div>
                <div className="text-[11px] text-slate-400">Total in Target</div>
            </div>
        </div>
    );
}
